// Curated marine generator catalog: brand → list of { type, kw } models.
// Same fallback semantics as engineCatalog: unknown brand or unknown type
// degrades to free text + manual kW.

export const GENERATOR_CATALOG = {
  "Kohler": [
    { type: "5EFKOZD", kw: 5 },
    { type: "9EOZ", kw: 9 },
    { type: "13EFOZ", kw: 13 },
    { type: "17EFOZ", kw: 17 },
    { type: "23EFOZ", kw: 23 },
    { type: "27EFOZ", kw: 27 },
    { type: "33EFOZ", kw: 33 },
    { type: "40EFOZ", kw: 40 },
    { type: "55EFOZ", kw: 55 },
    { type: "80EFOZ", kw: 80 },
    { type: "99EFOZ", kw: 99 },
    { type: "125EFOZ", kw: 125 },
  ],
  "Cummins Onan": [
    { type: "MDKAV", kw: 11 },
    { type: "MDKBT", kw: 13.5 },
    { type: "MDKBR", kw: 17.5 },
    { type: "QD13.5", kw: 13.5 },
    { type: "QD20", kw: 20 },
    { type: "QD27", kw: 27 },
    { type: "QD32", kw: 32 },
    { type: "QD45", kw: 45 },
    { type: "QD65", kw: 65 },
  ],
  "Onan": [
    { type: "MDKBN", kw: 9 },
    { type: "MDKBP", kw: 13.5 },
    { type: "MDKBR", kw: 17.5 },
  ],
  "Northern Lights": [
    { type: "M673L3", kw: 9.5 },
    { type: "M773LW3", kw: 12 },
    { type: "M843NW3", kw: 16 },
    { type: "M853CW3", kw: 20 },
    { type: "M864W3", kw: 25 },
    { type: "M65C13.1", kw: 32 },
    { type: "M65C13.5", kw: 40 },
    { type: "M99C8", kw: 55 },
    { type: "M99C2", kw: 65 },
    { type: "M150", kw: 99 },
  ],
  "Fischer Panda": [
    { type: "AGT 4000", kw: 3.5 },
    { type: "AGT 6000", kw: 5.5 },
    { type: "8 mini", kw: 6.4 },
    { type: "10 mini", kw: 8 },
    { type: "15 mini", kw: 12 },
    { type: "25", kw: 22 },
    { type: "30", kw: 26 },
    { type: "50", kw: 45 },
    { type: "80", kw: 75 },
  ],
  "Westerbeke": [
    { type: "5.0 BTDA", kw: 5 },
    { type: "7 BTDB", kw: 7 },
    { type: "8.5 BTDB", kw: 8.5 },
    { type: "11 BTDA", kw: 11 },
    { type: "12.5 BTDB", kw: 12.5 },
    { type: "15 BTDB", kw: 15 },
    { type: "27 EDTC", kw: 27 },
  ],
  "Caterpillar": [
    { type: "C2.2", kw: 22 },
    { type: "C4.4", kw: 80 },
    { type: "C7.1", kw: 200 },
    { type: "C9", kw: 250 },
    { type: "C13", kw: 400 },
    { type: "C18", kw: 600 },
  ],
  "Volvo Penta": [
    { type: "D5A T", kw: 99 },
    { type: "D7A T", kw: 145 },
    { type: "D11", kw: 280 },
    { type: "D13", kw: 400 },
  ],
  "Yanmar": [
    { type: "1GM10", kw: 6.5 },
    { type: "3JH40", kw: 29 },
    { type: "4JH80", kw: 59 },
  ],
};
